<template>
  <div class="text-left" v-if="event && !executing">
    <div class="mb-2">
      <label>Repeat Type</label>
      <mdb-input id="det0" label="No Repeat" name="det1" radioValue="None" type="radio"
                 v-model="event.repeatType"/>
      <mdb-input id="det1" label="Weekly" name="det1" radioValue="Weekly" type="radio"
                 v-model="event.repeatType"/>
      <mdb-input id="det2" label="Monthly" name="det2" radioValue="Monthly" type="radio"
                 v-model="event.repeatType"/>
      <mdb-input id="det3" label="Every Other Week (i.e., Biweekly/Fortnightly)" name="det3" radioValue="Biweekly"
                 type="radio"
                 v-model="event.repeatType"/>
    </div>

    <div class="mb-2" v-if="repeatType!='None'">
      <h5 class="text-warning"><i>Starting {{ event.formattedStart }}</i></h5>
    </div>

    <div class="mb-2" v-if="repeatType=='Monthly'">
      <gp-select :dataObj="event" :possible-values="repeatWeeks" :required="true" label="On the..."
                 propertyName="repeatWeek"/>
    </div>

    <div class="mb-2" v-if="repeatType=='Weekly' || repeatType=='Biweekly'">
      <label>Repeat Every...</label>
      <mdb-row>
        <mdb-col class="mr-4" col="1">
          <mdb-input id="monday" label="Mon" name="monday" type="checkbox" v-model="event.monday"/>
        </mdb-col>
        <mdb-col class="mr-4" col="1">
          <mdb-input id="tuesday" label="Tue" name="tuesday" type="checkbox" v-model="event.tuesday"/>
        </mdb-col>
        <mdb-col class="mr-4" col="1">
          <mdb-input id="wednesday" label="Wed" name="wednesday" type="checkbox" v-model="event.wednesday"/>
        </mdb-col>
        <mdb-col class="mr-4" col="1">
          <mdb-input id="thursday" label="Thu" name="thursday" type="checkbox" v-model="event.thursday"/>
        </mdb-col>
        <mdb-col class="mr-4" col="1">
          <mdb-input id="friday" label="Fri" name="friday" type="checkbox" v-model="event.friday"/>
        </mdb-col>
        <mdb-col class="mr-4" col="1">
          <mdb-input id="saturday" label="Sat" name="saturday" type="checkbox" v-model="event.saturday"/>
        </mdb-col>
        <mdb-col class="mr-4" col="1">
          <mdb-input id="sunday" label="Sun" name="sunday" type="checkbox" v-model="event.sunday"/>
        </mdb-col>
      </mdb-row>
    </div>
    <div v-if="!event.repeatEndDate && event.repeatType != 'None'">
      Repeat for 1 year, or....

    </div>

    <div class="md-form" v-if="repeatType!='None'">
      <div>
        <datetime :format="userDetails.dateFormat"
                  :maxDatetime="maxEndDate"
                  :minDatetime="event.startDate" :use12-hour="userDetails.timeFormat=='AM/PM'"
                  :valueZone="userDetails.timezone" :weekStart="userDetails.mondayFirst ? 1 : 7"
                  inputId="repeatEndDate" type="date"
                  :auto="true"
                  v-model="event.repeatEndDate">
        </datetime>
        <label class="active mr-5">Until</label>
      </div>
    </div>
    <div v-show="warningMessage" class="text-danger">
      {{warningMessage}}
    </div>

    <mdb-btn @click="doSave" color="success" icon="save">Save</mdb-btn>
    <mdb-btn @click="doCancel" color="danger" icon="times-circle">Cancel</mdb-btn>

  </div>

</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {mdbBtn, mdbCol, mdbIcon, mdbInput, mdbRow} from 'mdbvue';
import moment from 'moment'
import gpSelect from "../common/GPSelect";
import {Datetime} from 'vue-datetime'

export default {
  name: 'Event-Repeats-Editor',
  components: {
    mdbBtn,
    mdbIcon,
    mdbInput,
    mdbRow,
    mdbCol,
    Datetime,
    gpSelect
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  watch: {
    repeatType: function (n, o) {
      if (!o) return
      if (n != o) {
        this.event.sunday = false
        this.event.monday = false
        this.event.tuesday = false
        this.event.wednesday = false
        this.event.thursday = false
        this.event.friday = false
        this.event.saturday = false
        if (this.event.repeatType == "None") return
        this.event[this.dayOfWeek.toLowerCase()] = true
        this.event.repeatWeek = this.weekNumber
      }
    }
  }
  ,
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    }
    ,
    group() {
      return this.$store.state.currentGroup
    }
    ,
    executing() {
      return this.$store.state.executing
    }
    ,
    repeatType() {
      if (!this.event) return null
      return this.event.repeatType
    },
    warningMessage() {
      if (!this.event.status == 'Active') return null
      if (!this.originalData.repeats) return null
      if (this.originalData.repeatType != "None" && this.event.repeatType == "None") return "Warning: all existing uncompleted events after the first occurrence will be erased. Members will not be notified."

      if (this.event.repeatType != "None" && this.originalData.repeatType != "None") {
        let originalEnd = moment(this.originalData.repeatEndDate)
        let newEnd = moment(this.event.repeatEndDate)
        if (newEnd < originalEnd) return "Warning: existing uncompleted events after the new end date will be deleted. Members will not be notified."
      }
      if (this.originalData.repeatType == "Weekly" && this.event.repeatType != "Weekly") return "Warning: existing uncompleted events not in the new repeat scheme will be deleted. Members will not be notified."

      return null
    }
  }
  ,
  data() {
    return {
      event: null,
      originalData: null,
      dayOfWeek: "",
      weekNumber: 0,
      eventDate: null,
      startDateLocal: null,
      repeatWeeks: [],
      maxEndDate: null
    }

  }
  ,
  mounted() {
    this.$store.dispatch("setExecuting", true);
    api.get("/event/repeats/" + this.id).then(
      (results) => {
        this.event = results.data;
        this.originalData = JSON.parse(JSON.stringify(results.data))
        this.dayOfWeek = moment(this.event.startDate).format("dddd")
        this.maxEndDate = moment(this.event.startDate).add(1, 'y').format()
        this.weekNumber = Math.ceil(moment(this.event.startDate).date() / 7)
        this.startDateLocal = moment(this.event.startDate)
        this.repeatWeeks = [{text: "First " + this.dayOfWeek, value: 1},
          {text: "Second " + this.dayOfWeek, value: 2},
          {text: "Third " + this.dayOfWeek, value: 3},
          {text: "Fourth " + this.dayOfWeek, value: 4},
          {text: "*LAST* " + this.dayOfWeek, value: 9}]
      },
      (error) => {
        this.$notify.error({message: "Could not load rules. " + error.response.data, timeOut: 20000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  }
  ,
  methods: {
    doCancel() {
      this.$emit("cancel")
    }
    ,
    doSave() {
      this.$store.dispatch("setExecuting", true);
      api.post('/event/repeats/' + this.id, this.event).then(
        (results) => {
          this.$emit("save")
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    }
  }
}
;
</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>
